import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inventoryOrderHistoryActions } from "../../../../../store/external/inventory/history/order-history.reducer";
import { TablePagination } from "../../../../common/details-table/table-pagination.component";
//import { TablePaginationExhibit2 } from "../../../../common/table/table-pagination.component";
import ButtonIcon from "../../../../button";
import { requestDetailsActions } from "../../../../../store/external/request-reducer/request-details.reducer";

class OrderHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displaySearch: false,
            exportAlertMsg: "Please confirm that the harvesting of data and it's usage has been approved by the client.",
        }
    }

    componentDidMount() {
        this.props.getInventoryOrderHistory(this.props.circuitId);
    }

    onColumnSearch = () => {
        this.setState({ displaySearch: !this.state.displaySearch })
        const { getInventoryOrderHistory, circuitId } = this.props;
        getInventoryOrderHistory(circuitId, 0);
    }
    paginationAction = (pageIndex) => {
        const { getInventoryOrderHistory, circuitId } = this.props;
        getInventoryOrderHistory(circuitId, pageIndex);
    }

    loading = () => {
        return (
            <div className="loading-request-details-holder width-100 text-align-center">
                <div className="lds-default">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        );
    }
    openRequestModal = (item) => {
        const { setSelectedRequest } = this.props;
        setSelectedRequest(item);
        this.props.handelLink(item.RequestTypeId)
      }

    resizePage = (value) => {
        const { getInventoryOrderHistory, resizeInventoryOrderHistoryLogs } = this.props;
        resizeInventoryOrderHistoryLogs(value);
        getInventoryOrderHistory(this.props.circuitId, 0);
    }

    componentWillUnmount() {
        this.props.resetInventoryOrderHistory();
    }

    render() {
        const { getInventoryOrderHistory, inventoryOrderHistory, setInventoryOrderHistoryColSearchStr } = this.props;
        return (
            <>
                {
                   inventoryOrderHistory.isInventoryOrderHistoryLoaded ?
                     <TablePagination  
                        key="table-pagination-key"
                        columns={inventoryOrderHistory.inventoryOrderHistoryItems.Headers}
                        pageList={inventoryOrderHistory.inventoryOrderHistoryItems.Data.Items}                    
                        pages={inventoryOrderHistory.inventoryOrderHistoryItems.Pagination}
                        rowClickAction={this.openRequestModal }
                        paginationAction={this.paginationAction }
                        onColumnClick={() => { } }
                        onColumnSearch={() => { this.onColumnSearch() }}
                        onColumnSearchChange={setInventoryOrderHistoryColSearchStr}
                        isColSearchShow={this.props.displaySearch}
                        resizePage={this.resizePage}
                        totalPage={inventoryOrderHistory.inventoryOrderHistoryItems.Pagination.TotalEntries}
                        isNotSortable={true}
                        haveLink={true}                        
                    />

                  
                     :  this.loading()
                }              
            </>
        );
    }
}


export default connect(
    state => {
        const { inventoryOrderHistory } = state;

        return {
            inventoryOrderHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryOrderHistoryActions, requestDetailsActions),
        dispatch
    )
)(OrderHistory);